import { type PositionRiskRatings } from "@jsq/compliance-components";
import { type GetRiskRatingDetailsQuery } from "~/graphql/supergraphTypes";
import { getRiskRating } from "../../riskRating/utils";
import { getInvestingProfileName } from "../Profiles/utils";

type ComplianceCase = NonNullable<GetRiskRatingDetailsQuery["complianceCase"]>;
type ComplianceCaseProfile = NonNullable<ComplianceCase["profiles"]>[number];

type RiskRatingDetailsProps = {
  ratings: PositionRiskRatings;
  positionName: string | null | undefined;
  entityName: string | null | undefined;
};

const findBeneficiaryProfile = (complianceCase: ComplianceCase | null | undefined) => {
  if (!complianceCase) return null;
  const beneficiaryId = complianceCase.paymentAccount?.profileId;
  if (!beneficiaryId) return null;
  const investingProfile = complianceCase.investingProfile;
  const fromProfiles = complianceCase.profiles?.find(
    (profile: ComplianceCaseProfile) => profile?.id === beneficiaryId,
  );
  if (fromProfiles) return fromProfiles;
  if (investingProfile?.id === beneficiaryId) return investingProfile;
  return null;
};

export const buildRiskRatingDetailsProps = (
  complianceCase: ComplianceCase | null | undefined,
  usesProfiles: boolean,
): RiskRatingDetailsProps => {
  const investingProfile = complianceCase?.investingProfile;
  const beneficiary = findBeneficiaryProfile(complianceCase);
  const programId = complianceCase?.programId ?? undefined;

  return {
    ratings: {
      bankAccountDomicile: getRiskRating(complianceCase?.paymentAccount?.riskRating, programId),
      paymentBeneficiary: getRiskRating(beneficiary?.riskRating, programId),
      investor: getRiskRating(investingProfile?.riskRating, programId),
      position: complianceCase?.riskRating ?? null,
    },
    positionName: usesProfiles
      ? getInvestingProfileName(investingProfile)
      : complianceCase?.name,
    entityName: complianceCase?.externalEntity?.name,
  };
};
